export const GENSET_SUB_KATEGORI_CONSTANT = {
  GET_SUBKATEGORI_START: 'LI/POI/subkategori/get/requested',
  GET_SUBKATEGORI_FAILED: 'LI/POI/subkategori/get/failed',
  GET_SUBKATEGORI_SUCCESS: 'LI/POI/subkategori/get/success',

  RESET_STATUS: 'LI/POI/subkategori/reset-status',
  RESET_ALL: 'LI/POI/subkategori/reset-all',
};
